export const QUERY_KEYS = {
    GET_USER_DATA: 'GET_USER_DATA',
    COURSE_INFO: 'COURSE_INFO',
    ALL_COURSES: 'ALL_COURSES',
    PROCUCSTS: 'PRODUCTS',
    FILTERS: 'FILTERS',
    GET_DISINFECTION_TECHNIQUES_ARTICLES: 'DISINFECTION_ARTICLES',
    GET_KNOWLEDGE_BASE_ARTICLES: 'KNOWLEDGE_BASE_ARTICLES',
};
